import { useLocalStorage } from '@mantine/hooks';

export const useAuthTokens = () => {
  const [accessToken, setAccessToken, removeAccessToken] = useLocalStorage<string>({
    key: 'accessToken',
    defaultValue: undefined,
  });
  const [refreshToken, setRefreshToken, removeRefreshToken] = useLocalStorage<string>({
    key: 'refreshToken',
    defaultValue: undefined,
  });
  const [tokenExpiration, setTokenExpiration, removeTokenExpiration] = useLocalStorage<number>({
    key: 'tokenExpiration',
    defaultValue: undefined,
  });

  return {
    accessToken,
    setAccessToken,
    removeAccessToken,
    refreshToken,
    setRefreshToken,
    removeRefreshToken,
    tokenExpiration,
    setTokenExpiration,
    removeTokenExpiration,
  };
};
